module.exports = __webpack_public_path__ + "static/media/yrityksen-tiedot.e365917f.svg";